import { render } from "react-dom";
import dayjs from 'dayjs';
import { Modal ,Descriptions,Collapse, Typography} from "antd";
import * as json from "Common/Json";
import WrapperComponent from "Components/Wrapper";
import Toast from "Components/Toast";
import { historyState } from "../store/slice/history-slice";
import configureStore from "../store";
import { Close } from "Common/ReactIcons";
import utc from 'dayjs/plugin/utc';
import { AI_FORM_ITEMS_KEY_REPLACER } from "Common/constant";
const { store } = configureStore();
const { Panel } = Collapse;
const tabList = [
  {
    key: 'tab1',
    tab: 'A',
  },
  {
    key: 'tab2',
    tab: 'S',
  },
  {
    key: 'tab3',
    tab: 'E',
  },
  {
    key: 'tab4',
    tab: 'P',
  },
  {
    key: 'tab5',
    tab: 'T',
  },
  {
    key: 'tab6',
    tab: 'I',
  },
  {
    key: 'tab7',
    tab: 'C',
  },
]
const contentList = {
  tab1:<p>iibib</p>,
  tab2:<p>iijjbibib</p>,
  tab3:<p>iddibib</p>,
  tab4: <p>iqibib</p>,
  tab5:<p>iibqib</p> ,
  tab6:<p>iqibib</p>,
  tab7: <p>iiqbib</p>,
}
let modal, eventController, toastToggle = true, modalConfig = {};
let activeKey="tab1"
class Utils {
  renderTabContent=(val)=>{
// console.log(val)
  }
  IsObject(obj) {
    return typeof obj === 'object' && !Array.isArray(obj) && obj !== null;
  }

  IsPageReload() {
    return (
      (window.performance.navigation &&
        window.performance.navigation.type === 1) ||
      window.performance
        .getEntriesByType("navigation")
        .map((nav) => nav.type)
        .includes("reload")
    );
  }

  IsBackForwardClick() {
    return (
      (window.performance.navigation &&
        window.performance.navigation.type === 1) ||
      window.performance
        .getEntriesByType("navigation")
        .map((nav) => nav.type)
        .includes("back_forward")
    );
  }
  IsFunctionalComponent(component) {
    return (
      typeof component === "function" &&
      String(component).includes("return React.createElement")
    );
  }

  IsClassComponent(component) {
    return (
      typeof component === "function" && !!component.prototype.isReactComponent
    );
  }
  getOffSetInMinute(){
    dayjs.extend(utc)
    const now = dayjs();
    // Get the UTC offset in minutes
    const offsetInMinutes = now.utcOffset();
    return offsetInMinutes;
  }
  convertToTime(number) {
    const hours = Math.abs(Math.floor(number / 60));
    const minutes = Math.abs(number % 60);      
    // Format the time as "hh:mm"
    const formattedTime = ` GMT${number < 0 ? '-' : '+'}${hours}:${minutes.toString().padStart(2, '0')} `;      
    return formattedTime;
  }
  FormatDate(date, format = "DATE_TIME_1", startof) {
    if (date) {
      // console.log(date,"FIANL DATE INDEX__11")
      let finalDate = typeof data == "object" ? data : dayjs(date);
      // console.log(finalDate,"FIANL DATE INDEX")
      if (startof) finalDate.isValid() && finalDate.startOf(startof).format(json.formats[format]) || date;
      return finalDate.isValid() && finalDate.format(json.formats[format]) || date;
    } else date;
  }

  TimezoneOffsetConversion(){
    dayjs.extend(utc)
    let allData = JSON.parse(localStorage.getItem("persist:root"));
    let loginReducer = JSON.parse(allData.loginReducer);
    let resultDate =  dayjs.utc().add(loginReducer.user_details.time_zone_offset_in_min, 'minute')
    return(resultDate)
  }
  TimezoneOffsetConversionForPatient(time_zone_offset_in_min){
    dayjs.extend(utc)
    let resultDate =  dayjs.utc().add(time_zone_offset_in_min, 'minute')
    return(resultDate)
  }
  ConvertLocalTimeToUserOffset(time, offset){
    dayjs.extend(utc)
    let resultDate =  dayjs.utc(time).add(offset, 'minute')
    return(resultDate)
  }
  FormFocus(form, fields) {
    eventController = new AbortController();
    window.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && form.current && Array.isArray(fields)) {
        let formObj = form.current.getFieldsValue();
        let fieldsArray = fields || [];
        for (let i = 0; i < fieldsArray.length; i++) {
          if (!formObj[fieldsArray[i]]) {
            form.current.getFieldInstance(fieldsArray[i]).focus();
            break;
          }
        }
        event.preventDefault();
      }
    }, { signal: eventController.signal });
  }

  ConvertToUnderscores(str) {
    let frags = str?.split(' ');
    for (let i=0; i<frags?.length; i++) {
      frags[i] = frags[i]?.charAt(0)?.toLowerCase() + frags[i]?.slice(1);
    }
    return frags.join('_');
  }

  ConvertToPascalCase(str) {
    if(!str) return "";
    let frags = str.split('_');
    for (let i=0; i<frags.length; i++) {
      frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
    }
    return frags.join(' ');
  }

  ConvertToKebabCase(str) {
    let frags = str.split('_');
    for (let i=0; i<frags.length; i++) {
      frags[i] = frags[i].charAt(0).toLowerCase() + frags[i].slice(1);
    }
    return frags.join('-');
  }
  
  RemoveListener() {
    eventController.abort()
  }

  Sort(data, orderBy, sortBy, isDate) {
    if (Array.isArray(data)) {
      let order = orderBy == "asc" ? -1 : 1
      return data.sort((a, b) => {
        let first = typeof a == "object" && typeof sortBy == "string" ? a[sortBy] : a,
          second = typeof b == "object" && typeof sortBy == "string" ? b[sortBy] : b;
        if(isDate) {
          if(dayjs(first).isAfter(second)) return 1 * order;
          if(dayjs(second).isAfter(first)) return -1 * order;
        }
        else {
          if (first < second) return 1 * order;
          if (first > second) return -1 * order;
        }
        return 0;
      });
    }

    return data;
  }

  Toast(props) {
    toastToggle = !toastToggle
    render(<Toast {...props} show={toastToggle} />, document.getElementById("toast-container"));
  }

  Render(component, data, options) {
    let Wrapper = WrapperComponent(component, data, options);
    return <Wrapper />
  }

  Modal(open, customProps) {
    let { title, content, bodyStyle, width, onClose, closable = true } = this.IsObject(customProps)&&  customProps || {};
    if (open == true) {
      modalConfig = {
        ...modalConfig,
        callback: onClose,
      }
      modal = Modal.success({
        title: title || null,
        closable: closable,
        closeIcon: closable ? <Close /> : null,
        afterClose: () => {
          typeof modalConfig.callback == "function" && modalConfig.callback(modalConfig.data);
          modalConfig = {};
        },
        icon: null,
        centered: true,
        width: width || "300px",
        okButtonProps: {
          style: {
            display: "none",
          },
        },
        content: (
          <div style={bodyStyle || { height: "100%", overflow: "auto" }}>
            {content || null}
          </div>
        ),
      });
    }

    if (!open && modal) {
      modalConfig = {
        ...modalConfig,
        data: customProps,
      }
      modal.destroy();
    }
  }

  Capitalize(string) {
    return string && string.charAt(0).toUpperCase() + string.slice(1);
  }

  getDisplayName(firstName, lastName="") {
    return firstName + " " + lastName;
  }

  LineSplit(datas) {
    return typeof datas == "string" ? datas?.split("\n").map((item, a)=> {
        return (
        <>
        {item}
        <br /> 
        </>) 
        }) : ""
 }
  salutationPrefix(salutation,name){
    return(<div style={{ padding: "0px 14px", fontWeight: 500, borderRadius: "20px" }} >
        {salutation ? salutation+". "+name : name}
    </div>)
  }

  salutationPrefixName(salutation,name){
    return salutation ? salutation+". "+name : name
  }

  FormatName(name, isDoctor) {
    let splitArray = name?.split(" ") || [], finalArray = [];
    splitArray.forEach((m) => {
      if (m && m.length && typeof m == "string") {
        finalArray.push(this.Capitalize(m.trim()));
      }
    });

    if (isDoctor) {
      return `${finalArray.join(" ")}`;
    }

    return finalArray.join(" ");
  }

  Typography(text){
    return(
        <Typography>
          <Typography.Text ellipsis={{tooltip: this.Capitalize(text)}} >
            {this.Capitalize(text)}
          </Typography.Text>
        </Typography>
    )
  }

  FirstNameLastName(text, width){
    return(
        <Typography>
          <Typography.Text style={{maxWidth: width}} ellipsis={{tooltip: text}} >
            {text}
          </Typography.Text>
        </Typography>
    )
  }

  FirstNameLastNameLink(text, width){
    return(
        <Typography>
          <Typography.Text style={{maxWidth: width}} ellipsis={{tooltip: text}}>
            <Typography.Link>
              {text}
            </Typography.Link>
          </Typography.Text>
        </Typography>
    )
  }

  PercentageCalculation(answered, totalQuestion){
    let PercentageComplete = (answered/totalQuestion) * 100
    return PercentageComplete.toFixed()
  }

  ReturnPlanIfNot(planName)
  {
    if(planName.toLowerCase().includes("plan"))
    {
      return this.ConvertToPascalCase(planName)
    }else{
      let result = planName+" Plan"
      return this.ConvertToPascalCase(result)
    }
  }

  SetHistoryData(payload) {
    store.dispatch(historyState(payload));
  }

  GetHistoryData() {
    let defaultStore = store.getState();
    return defaultStore.historyReducer?.history_state;
  }
RenderTabData(data){
  return(
    <div>
      <p>lln</p>
    </div>
  )
}
  RestrictNegativeNumbers(e){
    e.nativeEvent.key =='-' || e.nativeEvent.key =='+' || e.nativeEvent.key=='e'?e.preventDefault():null
  }
  RecursiveSummary(value)
  {
    return(
      Object.entries(value || {}).map(([FormItemKey, FormItemData]) => 

      {
          
              if(FormItemData.title){ 
              return(
                  this.RecursiveSummary(FormItemData.values))
              }   
              else if(Array.isArray(FormItemData.values)&&FormItemData.label)
              {
                  return(
                      <div>
                            {FormItemData.values.map((selected)=>{
                              return( selected.is_selected?
                                  <>
                                  <Descriptions
                                   bordered
                                   size="middle"
                                   contentStyle={{width:"40%"}}
                                   labelStyle={{width:"50%"}}>
                                  <Descriptions.Item label={FormItemData.label}>{selected.label}</Descriptions.Item>
                                  </Descriptions>
                                  </>:null)
                          })}
                      </div>
                      
                  )
              }  
              else
              {
                return(this.RecursiveSummary(FormItemData))                
              }   
      })
      )
  }
  onTab1Change=(val,data)=>{
  activeKey=val
  return(
this.renderTabContent(val)
  )
      }
  
  splitQuestion=(question,language)=>{
      let primLangTxt="";
      let prefLangTxt="";
   if(question.includes("/n"))
   {
     prefLangTxt=question.split("/n")[0];
     primLangTxt=question.split("/n")[1];
   } else {primLangTxt=question;}
   return(
    <>{prefLangTxt ?<> <span className={language+"-txt"}>
    {`${prefLangTxt}`}</span><br/></>:null} 
   <span className="en-txt"> {`${primLangTxt}`}</span>
   </>
   )
  }  
  generateNumbersArray(data) {
    return Array.from({ length: data.length }, (_, index) => index);
  }
  capitalizeAndReplace(str) {
    if(AI_FORM_ITEMS_KEY_REPLACER[str]){
      return AI_FORM_ITEMS_KEY_REPLACER[str];
    }
    return str
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
  }
  extractAfterLastSentenceDelimiter(text) {
    // Trim any leading or trailing whitespace
    text = text.trim();
    
    // Split text based on the delimiters
    const parts = text.split(/(?<=[.!?])\s*/);
    
    // Return the last part after removing leading/trailing whitespace
    return parts.length > 0 ? parts[parts.length - 1].trim() : '';
}
  numberToWords(num){
    const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
    const teens = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
    const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
    const scales = ['', 'thousand', 'million', 'billion'];

    const convertHundreds = (num) => {
      if (num === 0) return '';
      if (num < 10) return ones[num];
      if (num < 20) return teens[num - 10];

      const onesDigit = num % 10;
      const tensDigit = Math.floor(num / 10) % 10;
      const hundredsDigit = Math.floor(num / 100);

      let words = '';
      if (hundredsDigit !== 0) {
        words += ones[hundredsDigit] + ' hundred';
      }
      if (tensDigit === 1) {
        words += (words ? ' ' : '') + teens[onesDigit];
      } else {
        if (tensDigit !== 0) {
          words += (words ? ' ' : '') + tens[tensDigit];
        }
        if (onesDigit !== 0) {
          words += (words ? ' ' : '') + ones[onesDigit];
        }
      }

      return words.trim();
    };

    if (num === 0) return 'zero';

    let rupees = Math.floor(num);
    let paisa = Math.round((num - rupees) * 100);

    let rupeesWords = '';
    let scaleIndex = 0;

    while (rupees > 0) {
      const hundreds = rupees % 1000;
      if (hundreds !== 0) {
        const partWords = convertHundreds(hundreds);
        rupeesWords = `${partWords} ${scales[scaleIndex]} ${rupeesWords}`.trim();
      }

      rupees = Math.floor(rupees / 1000);
      scaleIndex++;
    }

    rupeesWords = rupeesWords + ' rupees';

    if (paisa > 0) {
      let paisaWords = convertHundreds(paisa);
      paisaWords = paisaWords + ' paisa';
      return `${rupeesWords} and ${paisaWords}`.trim();
    }

    return rupeesWords.trim();
  }
  allowedRoute(selectedKeys, routeobj) {
    return selectedKeys.reduce((acc, key) => {
      if (key in routeobj) {
        acc.push(routeobj[key]);
      } else {
        console.log(`Key ${key} is missing in routeobj`);
      }
      return acc;
    }, []);
  }
  getFilteredValues = (keysToExcludeFilter, initialValues = {}, currentValues = {}) => {
    const result = {};
    let changedCount = 0;
    let excludedKeysChanged = 0;
  
    for (let key in currentValues) {
      const initVal = initialValues[key];
      const currVal = currentValues[key];
      if (typeof currVal === "object" && !Array.isArray(currVal)) {result[key] = currVal;continue;}
      // Handle excluded keys
      if (keysToExcludeFilter.includes(key)) {
        if (initVal !== currVal) {
          excludedKeysChanged++;
        }
        result[key] = currVal;
        continue;
      }
  
      // If key is new (not in initial values), it's a change
      if (initVal === undefined) {
        changedCount++;
        result[key] = currVal;
        continue;
      }
  
      // Handle array comparison ignoring order
      if (Array.isArray(initVal) && Array.isArray(currVal)) {
        const initSet = new Set(initVal);
        const currSet = new Set(currVal);
        if (initSet.size !== currSet.size || [...initSet].some(item => !currSet.has(item))) {
          changedCount++;
          result[key] = currVal;
        } else {
          result[key] = [];
        }
        continue;
      }
  
      // Handle primitive type comparison
      if (typeof initVal !== 'object' && typeof currVal !== 'object') {
        if (initVal !== currVal) {
          changedCount++;
          result[key] = currVal;
        } else {
          result[key] = typeof currVal === 'string' ? "" : currVal;
        }
      }
    }
  
    return { result, changedCount, excludedKeysChanged };
  };

  isModified = (initialObject, currentObject) => {
    const recursiveCheck = (initObj, currObj) => {
      if (typeof initObj !== 'object' || typeof currObj !== 'object') {
        // If the values are not objects, check for strict equality
        return initObj !== currObj;
      }
  
      // Handle arrays and objects separately
      if (Array.isArray(initObj) && Array.isArray(currObj)) {
        // Check if arrays have different lengths or any differing elements
        if (initObj.length !== currObj.length) return true;
  
        return initObj.some((item, index) => recursiveCheck(item, currObj[index]));
      }
  
      if (!Array.isArray(initObj) && !Array.isArray(currObj)) {
        // Check if any keys are added/removed or if values differ
        const initKeys = Object.keys(initObj);
        const currKeys = Object.keys(currObj);
  
        if (initKeys.length !== currKeys.length) return true;
  
        return initKeys.some(key => recursiveCheck(initObj[key], currObj[key]));
      }
  
      // If one is an array and the other isn't, they are different
      return true;
    };
  
    return recursiveCheck(initialObject, currentObject);
  };
  deepCopy(obj) {
    if (obj === null || typeof obj !== "object") {
      return obj;
    }
  
    if (Array.isArray(obj)) {
      return obj.map(this.deepCopy);
    }
  
    return Object.keys(obj).reduce((acc, key) => {
      acc[key] = this.deepCopy(obj[key]);
      return acc;
    }, {});
  }
}

export default new Utils();
